import * as ko from "knockout";
import * as $ from "jquery";
import { KnockoutExtensions, NumericValidationOptions } from "../KnockoutExtensions/knockoutextensions";
import "../Templates/validation-error-template.html";
import { LoginResponse } from "../Models/loginresponse";
import { BaseViewModel, HttpAction, CustomWindow } from "./baseviewmodel";
import * as QRCode from "qrcode";

class LoginViewModel extends BaseViewModel {

    public email = ko.observable<string>(null).extend({ required: true });
    public password = ko.observable<string>(null).extend({ required: true });
    public returnUrl = ko.observable<string>(null);
    public failureMessage = ko.observable<string>(null);
    public sharedKey = ko.observable<string>(null);
    public twofaCode = ko.observable<number>(null);
    public twofaState = ko.observable<number>(0);

    constructor(paramters: string) {
        super(paramters);
        this.classname = "LoginViewModel";

        this.email(this.email());
        this.password(this.password());
        this.returnUrl(this.returnUrl());
    }

    public getPersistenceIncludedProperties(): string[] { return ["email", "password", "returnUrl"]; }

    public getPersistenceIgnoredProperties(): string[] {
        return super.getPersistenceIgnoredProperties().concat(["failureMessage"]);
    }

    public signIn() {
        var results = this.validate();
        if (results == null) {
            this.isBusy(true);
            this.postJsonData("/api/account/login", this.toJs(), (response: LoginResponse) => {
                if (response.isSuccess) {
                    this.isBusy(false);
                    this.writeSetting("nutricalc-login", this.email());

                    if (response.requires2FA) {
                        this.twofaState(response.twofactorState);
                        if (this.twofaState() == 1) {
                            this.sharedKey(response.sharedKey);
                            QRCode.toCanvas(document.getElementById("qrcode"), response.twoFactorURL, {
                                width: 128
                            }, null);
                        }
                    } else {
                        (window as CustomWindow).sessionState.setCanAccess(true);
                        this.writeSetting("isLoggedIn", "1");
                        this.navigateTo("home", "dashboard", "Dashboard", "dashboard");
                    }
                } else {
                    this.failureMessage(response.failureMessage);
                }
            }, () => this.isBusy(false));
        }
    }

    public verifyCode() {
        this.isBusy(true);
        this.postJsonData("/api/account/verifycode", this.twofaCode(), (response: boolean) => {
            this.isBusy(false);
            if (response) {
                (window as CustomWindow).sessionState.setCanAccess(true);
                this.writeSetting("isLoggedIn", "1");
                this.navigateTo("home", "dashboard", "Dashboard", "dashboard");
            } else {
                this.failureMessage("Invalid verification code supplied. Please re-enter the code or new code.");
            }
        });
    }

    public nextStep() {
        this.twofaState(2);
    }

    public resetPassword() {
        this.redirectTo("/account/forgotpassword" + (this.email() != null ? `?emailAddress=${encodeURIComponent(this.email())}` : ""));
    }

    public init() {
    }
}

export { LoginViewModel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/loginviewmodel.ts